module.exports = __webpack_public_path__ + "static/fonts/condensed-medium.a7dd3f4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Fonts/Futura/condensed-medium.ttf
// module id = 525
// module chunks = 0